/**
 * GLightbox — клік по зображенню галереї відкриває його у лайтбоксі
 * з навігацією по всій галереї проєкту.
 *
 * Розмітка: <a class="gallery-item" href="<full-image>" data-gallery="project">…</a>
 * (data-gallery групує всі знімки одного проєкту в одну галерею).
 *
 * Бібліотека потрібна лише на сторінках проєктів, тож тут — тільки дешева
 * перевірка DOM, а GLightbox (JS + CSS) тягнеться динамічним import()
 * окремим чанком. Раніше import стояв на верхньому рівні: гард пропускав
 * ініціалізацію, але бібліотека все одно качалась і парсилась на КОЖНІЙ
 * сторінці, б'ючи по Total Blocking Time.
 */
export default async function lightbox() {
  if (!document.querySelector('.gallery-item')) return;

  const { default: init } = await import(
    /* webpackChunkName: "glightbox" */ './lightboxInit.js'
  );
  init();
}
